export default __webpack_public_path__ + "locales/sl/Ldap.json?hash=20d6c0e0a2baaf1ed7f9093d8ea50a8c";